const InputField = ({
    label,
    value,
    onChange,
    placeholder = "",
    disabled = false,
    ipdata = "",
}) => {
    return (
        <div className="md:w-[250px]">
            <label className="block text-md font-xl text-primary">
                {label}<span className="text-red-500">*</span>
            </label>

            <input
                className={`w-full border rounded px-3 py-2 mt-1 
                    ${disabled ? "hidden bg-gray-100 cursor-not-allowed text-gray-600" : ""}
                `}
                value={value}
                placeholder={placeholder}
                onChange={(e) => !disabled && onChange(e.target.value)}
                disabled={disabled}
            />
            <span className={`${disabled ? "block" : "hidden"}`}>{ipdata}</span>
        </div>
    );
};

export default InputField;
